import glamorous from 'glamorous';

export const ButtonWrapper = glamorous.button(() => ({
  display: 'inline-block',
  padding: '0.8em 3em',
  margin: '0',
  boxSizing: 'border-box',
  background: '#111',
  color: '#ffffff',
  borderRadius: '5em',
  fontSize: '14px',
  textAlign: 'center',
  fontWeight: 'bold',
  transition: 'all 0.2s ease-out',
  '&:disabled': {
    opacity: '.7',
    background: '#DDD',
  },
  ':focus': {
    outline: 'none',
  },
}));
ButtonWrapper.displayName = 'ButtonWrapper';

export const LabelWrapper = glamorous.span(({ hidden }) => ({
  visibility: hidden ? 'hidden' : 'visible',
}));
LabelWrapper.displayName = 'LabelWrapper';



// WEBPACK FOOTER //
// ./src/components/Button/Button.style.js